/**
 * Utility formatters for the application
 */

/**
 * Strips "(Personal)" suffix from organization names for cleaner display
 * @param {string} name - The organization name
 * @returns {string} - The cleaned name without "(Personal)" suffix
 */
export const cleanOrgName = (name) => {
  if (!name) return '';
  return name.replace(/\s*\(Personal\)\s*/gi, '').trim();
};

/**
 * Formats a user's display name from user object
 * @param {Object} user - The user object with name/email
 * @returns {string} - The formatted display name
 */
export const formatUserDisplayName = (user) => {
  if (!user) return 'User';
  const name = user.name || user.email?.split('@')[0] || 'User';
  return cleanOrgName(name); // Also clean user names in case they have (Personal)
};
